module.exports = __webpack_public_path__ + "static/Groupe-1-0db347c04964902bb1f7f995191f043d.png";